"use client";

/**
 * Small neutral gateway chip (MT5 / ViiSync) — chip surface, mono, uppercase.
 * Proposal 19: answers "which gateway does this account ride on?" at a glance.
 * Colour discipline: neutral only — status stays on dots, selection on the blue edge.
 */
export function GatewayChip({ label, className = "" }: { label: string; className?: string }) {
  return (
    <span
      className={`inline-flex items-center h-[15px] px-1.5 rounded-full bg-muted border border-border text-muted-foreground font-mono text-[9px] font-semibold uppercase tracking-wide shrink-0 ${className}`}
    >
      {label}
    </span>
  );
}

export default GatewayChip;
